<template>
  <div>
    <transition name="fade">
      <div v-if="showNotification" :class="notificationClass">
        {{ notificationMessage }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'NetworkStatusNotification',
  data() {
    return {
      isOnline: navigator.onLine,
      showNotification: false,
      notificationMessage: '',
      notificationClass: '',
    }
  },
  mounted() {
    window.addEventListener('online', this.handleOnline)
    window.addEventListener('offline', this.handleOffline)
  },
  beforeUnmount() {
    window.removeEventListener('online', this.handleOnline)
    window.removeEventListener('offline', this.handleOffline)
  },
  methods: {
    handleOnline() {
      this.isOnline = true
      this.showNotification = true
      this.notificationMessage = 'Đã khôi phục kết nối Internet.'
      this.notificationClass = 'notification online'
      this.hideNotificationAfterDelay()
    },
    handleOffline() {
      this.isOnline = false
      this.showNotification = true
      this.notificationMessage = 'Mất kết nối Internet.'
      this.notificationClass = 'notification offline'
    },
    hideNotificationAfterDelay() {
      setTimeout(() => {
        this.showNotification = false
      }, 3000)
    }
  }
}
</script>

<style scoped>
.notification {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 14px;
  font-size: 16px !important;
  text-align: center;
  font-weight: 500;
  z-index: 9999;
}

.online {
  background-color: #4CAF50;
  color: white;
}

.offline {
  background-color: #F44336;
  color: white;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>